var _desc, _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoadImageIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Created with Pixso.\n  ")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10967_28843"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icons",
    width: 24,
    height: 24,
    transform: "translate(8.000000 8.000000)",
    fill: "white",
    fillOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip10967_28842"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Frame 149285988",
    rx: 20,
    width: 40,
    height: 40,
    fill: "white",
    fillOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Frame 149285988",
    rx: 20,
    width: 40,
    height: 40,
    fill: "#EDF6FA",
    fillOpacity: 1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10967_28842)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Icons",
    width: 24,
    height: 24,
    transform: "translate(8.000000 8.000000)",
    fill: "#FFFFFF",
    fillOpacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip10967_28843)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 7",
    d: "M13 23L13 26C13 26.5508 13.4478 27 14 27L26 27C26.5522 27 27 26.5508 27 26L27 23",
    stroke: "#388AF7",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 253",
    d: "M20 13L20 22M24 18L20 22L16 18",
    stroke: "#388AF7",
    strokeOpacity: 1,
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoadImageIcon);
export default __webpack_public_path__ + "static/media/load_image_icon.73d91b260660272e37b9588c9fd0e589.svg";
export { ForwardRef as ReactComponent };